@if (item) {
  <div class="column policy-header is-8">
    <div class="title-section">
      <h1 class="is-2 has-text-weight-light" [title]="item.name">
        {{ item.englishName | truncate : ['50'] }}
      </h1>
      @if (item.editorialStatus === EditorialStatus.Pending) {
        <span class="tag is-warning ml-2">Pending</span>
      } @else if(item.editorialStatus === EditorialStatus.Rejected) {
        <span class="tag is-black ml-2">Rejected</span>
      } @else if(item.editorialStatus === EditorialStatus.Published) {
        <span class="tag is-success ml-2">Published</span>
      } @else if (item.editorialStatus === EditorialStatus.Draft) {
        <span class="tag is-disabled ml-2">Draft</span>
      }
    </div>

    <div class="action-controls">
      @if (item.isEditable) {
        <a
          class="action-button edit-button"
          [routerLink]="['/policy-initiatives/' + item.id + '/edit']"
          title="Edit Policy Initiative"
        >
          <i aria-hidden="true" class="icon icon-edit"></i>
          <span>Edit</span>
        </a>
      }

      @if (item.isEditorialStatusUpdatable) {
        @if (item.editorialStatus === EditorialStatus.Pending) {
          <a
            class="action-button publish-button"
            [caseAction]="publishAction"
            title="Publish Policy Initiative"
          >
            <i aria-hidden="true" class="icon icon-file-text"></i>
            <span>Publish</span>
          </a>

          <a
            class="action-button reject-button"
            [caseAction]="rejectAction"
            title="Reject Policy Initiative"
          >
            <i aria-hidden="true" class="icon icon-x"></i>
            <span>Reject</span>
          </a>
        } @else if(item.editorialStatus === EditorialStatus.Published ||
            item.editorialStatus === EditorialStatus.Rejected) {
          <a
            class="action-button pending-button"
            [caseAction]="pendingAction"
            title="Switch to Pending Status"
          >
            <i aria-hidden="true" class="icon icon-clock"></i>
            <span>Set Pending</span>
          </a>
        }
      }

      @if (item.isDeletable) {
        <a
          class="action-button delete-button"
          [caseAction]="deleteAction"
          title="Delete Policy Initiative"
        >
          <i aria-hidden="true" class="icon icon-delete"></i>
          <span>Delete</span>
        </a>
      }
    </div>
  </div>

  <div class="columns is-multiline">
    <div class="column is-8">
      <div class="card">
        <div class="card-content">
          <!-- Policy Initiative Steps -->
          <div class="policy-steps-section mb-6">
            <div class="is-multiline">
              <app-policy-initiative-view
                [policyInitiativeViewDefinition]="policyInitiativeViewDefinition()">
              </app-policy-initiative-view>
            </div>
          </div>
          
          <!-- Metadata Section -->
          <div class="metadata-section">
            <div class="section-header mb-5">
              <div class="is-flex is-align-items-center">
                <span class="icon is-small mr-2 has-text-grey-dark">
                  <i class="fas fa-info-circle"></i>
                </span>
                <h4 class="title is-6 has-text-weight-semibold has-text-grey-dark mb-0">
                  Record Information
                </h4>
              </div>
              <div class="mt-2" style="height: 2px; background: linear-gradient(90deg, #3273dc 0%, #e8e8e8 100%); border-radius: 1px;"></div>
            </div>
            <div class="columns is-multiline">
              <div class="column is-6">
                <div class="metadata-card has-background-white" 
                     style="border: 1px solid #e8e8e8; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); transition: all 0.3s ease;">
                  <div class="is-flex is-align-items-center mb-3">
                    <span class="icon is-small mr-2" style="color: #48c774;">
                      <i class="fas fa-user-plus"></i>
                    </span>
                    <p class="is-uppercase has-text-grey-dark has-text-weight-bold is-size-7 mb-0" style="letter-spacing: 0.5px;">
                      Created By
                    </p>
                  </div>
                  <div class="metadata-content">
                    <p class="is-size-6 has-text-weight-semibold has-text-dark mb-1">{{ item.createdByName | emptyPlaceHolder }}</p>
                    <p class="is-size-7 has-text-grey">{{ item.createdByEmail | emptyPlaceHolder }}</p>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="metadata-card has-background-white" 
                     style="border: 1px solid #e8e8e8; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); transition: all 0.3s ease;">
                  <div class="is-flex is-align-items-center mb-3">
                    <span class="icon is-small mr-2" style="color: #ff9800;">
                      <i class="fas fa-user-edit"></i>
                    </span>
                    <p class="is-uppercase has-text-grey-dark has-text-weight-bold is-size-7 mb-0" style="letter-spacing: 0.5px;">
                      Last Updated By
                    </p>
                  </div>
                  <div class="metadata-content">
                    <p class="is-size-6 has-text-weight-semibold has-text-dark mb-1">{{ item.updatedByName | emptyPlaceHolder }}</p>
                    <p class="is-size-7 has-text-grey">{{ item.updatedByEmail | emptyPlaceHolder }}</p>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="metadata-card has-background-white" 
                     style="border: 1px solid #e8e8e8; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); transition: all 0.3s ease;">
                  <div class="is-flex is-align-items-center mb-3">
                    <span class="icon is-small mr-2" style="color: #3273dc;">
                      <i class="fas fa-calendar-plus"></i>
                    </span>
                    <p class="is-uppercase has-text-grey-dark has-text-weight-bold is-size-7 mb-0" style="letter-spacing: 0.5px;">
                      Created At
                    </p>
                  </div>
                  <div class="metadata-content">
                    <p class="is-size-6 has-text-weight-semibold has-text-dark">{{ item.createdAt | date }}</p>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="metadata-card has-background-white" 
                     style="border: 1px solid #e8e8e8; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); transition: all 0.3s ease;">
                  <div class="is-flex is-align-items-center mb-3">
                    <span class="icon is-small mr-2" style="color: #9c27b0;">
                      <i class="fas fa-calendar-check"></i>
                    </span>
                    <p class="is-uppercase has-text-grey-dark has-text-weight-bold is-size-7 mb-0" style="letter-spacing: 0.5px;">
                      Updated At
                    </p>
                  </div>
                  <div class="metadata-content">
                    <p class="is-size-6 has-text-weight-semibold has-text-dark">{{ item.updatedAt | date }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Feedback Section -->
          <div class="feedback-section mt-6">
            <div class="section-header mb-5">
              <div class="is-flex is-align-items-center">
                <span class="icon is-small mr-2 has-text-grey-dark">
                  <i class="fas fa-comment-dots"></i>
                </span>
                <h4 class="title is-6 has-text-weight-semibold has-text-grey-dark mb-0">
                  We Look Forward to Your Feedback!
                </h4>
              </div>
              <div class="mt-2" style="height: 2px; background: linear-gradient(90deg, #3273dc 0%, #e8e8e8 100%); border-radius: 1px;"></div>
            </div>
            <div class="feedback-content has-background-white"
                 style="border: 1px solid #e8e8e8; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
              <p class="mb-4">
                Please send us an e-mail to
                <a href="mailto:policy.navigator@oecdai.org" class="has-text-link has-text-weight-semibold">
                  policy.navigator&#64;oecdai.org
                </a>
                and tell us about your experience using the Policy Navigator's new submission dashboard.
                We are particularly interested in the following aspects:
              </p>
              <ul class="ml-4 mb-4" style="list-style-type: disc;">
                <li>Problems or technical difficulties encountered</li>
                <li>Features that you would suggest adding</li>
                <li>Features that you would suggest removing or modifying</li>
                <li>Overall user experience</li>
              </ul>
              <p class="mb-2">Thanks sincerely in advance for your inputs.</p>
              <p class="has-text-weight-semibold">Best regards,<br>The OECD.AI Team</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (item.editorialStatus === EditorialStatus.Published) {
      <div class="sticky-container">
        <div class="sticky-label">
          <a
            [href]="environment.policyInitiativePath + item.slug"
            target="_blank"
            class="button is-info"
          >
            <span class="icon is-small">
              <i aria-hidden="true" class="icon icon-eye"></i>
            </span>
            <span>View as public</span>
          </a>
        </div>
      </div>
    }
  </div>
}
